import {Tooltip, Button, Flex} from "antd"
import getIcon from "EstruturaAntiga/components/navigation/components/getIcons";

const BotoesAcaoListagem = ({handleRestaurarClick, linhasSelecionadas, restaurarButtonRef}) => {

    return(
        <Flex
            justify='flex-start'
            align='center'
            style={{ height: '40px', background: '#f8f9fa', boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)", margin: "10px 0", borderRadius:"5px", padding:"3px 10px" }}
        >                
            <div style={{ width:'fit-content' }}>
                <Tooltip title={linhasSelecionadas.length === 0 ? "Selecione um usuário para restaurar" : ""}>
                    <Button 
                        type="text" 
                        onClick={handleRestaurarClick}
                        disabled={!linhasSelecionadas.length > 0}
                        ref={restaurarButtonRef}
                        icon={<img src={getIcon('icon-usuario-restaurar')} style={{ width: 19, height: 19 }} />}
                    >
                        Restaurar Usuário
                    </Button>
                </Tooltip>
            </div>
        </Flex>
    )
}

export default BotoesAcaoListagem;